import { render } from "./TemplateCardV2.vue?vue&type=template&id=00c2af53&scoped=true"
import script from "./TemplateCardV2.vue?vue&type=script&lang=js"
export * from "./TemplateCardV2.vue?vue&type=script&lang=js"

import "./TemplateCardV2.vue?vue&type=style&index=0&id=00c2af53&lang=scss&scoped=true"
import "./TemplateCardV2.vue?vue&type=style&index=1&id=00c2af53&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00c2af53"]])

export default __exports__